import { TableSearch } from './table-search';

export default TableSearch;
